// extracted by mini-css-extract-plugin
export default {"IFTextInputStyle":"AddCityModal_IFTextInputStyle__Vwsm6","AddIconStyle":"AddCityModal_AddIconStyle__cpOid"};